import {
  SalesOrderStatus,
  enumSalesOrderSortOption,
} from '@rematter/frontend-lib-api-client';

import { createEntityComboBox } from './helpers/createEntityComboBox';

import { createQueryHook } from '~/shared/providers/api';
import { QueryHookResult } from '~/shared/providers/api/createQueryHook';
import {
  formatAddressDisplay,
  formatSalesOrderLabel,
} from '~/shared/utils/salesOrderFormatting';

export type SelectableSalesOrder = QueryHookResult<
  typeof useSalesOrdersList
>[number];

export const useSalesOrdersList = createQueryHook(
  'shared.selectSalesOrder',
  (params: {
    ids?: string[];
    searchTerm?: string;
    facilityIds?: string[];
    accountIds?: string[];
    statuses?: SalesOrderStatus[];
  }) => ({
    salesOrders: {
      __args: {
        filter: {
          ids: params.ids,
          searchTerm: params.searchTerm,
          facilityIds: params.facilityIds,
          accountIds: params.accountIds,
          status: params.statuses,
        },
        sorting: [enumSalesOrderSortOption.CreatedAtDesc],
        pagination: {
          limit: 20,
          offset: 0,
        },
      },
      entries: {
        id: true,
        documentNumber: true,
        type: true,
        status: true,
        counterpartyReferenceNumber: true,
        account: {
          name: true,
        },
        startDate: true,
        endDate: true,
        shippingAddress: {
          addressType: true,
          streetAddress: true,
          city: true,
          state: true,
          postalCode: true,
        },
      },
    },
  }),
  {
    select: (data) => data.salesOrders.entries ?? [],
  },
);

export const SelectSalesOrder = createEntityComboBox.remotelySearched(
  'SelectSalesOrder',
  useSalesOrdersList,
  {
    formatLabel: formatSalesOrderLabel,
    formatSubLabel: (entity) =>
      entity.shippingAddress
        ? formatAddressDisplay(entity.shippingAddress)
        : '',
    compactSelection: true,
  },
);
